// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__iRHOz","vertical":"Divider_vertical__pP6aX"};